//messages.js
export default {
    category_id: "Category #",
    category: "Category",
    system_list: "System List",
    status: "Status",
    edit_options_category: "Edit Option",
    add_options_category: "Add Option",
    delete_options_category: "Delete Option",
    options_categories: "Options",

    /* options */
    option: "Option",
    value: "Value",
    slug: "Slug",
    class: "Class",
    sort_by: "Sort By",
    sort_order: "Sort Order",
    status: "Status",
    edit_option: "Edit Option",
    add_option: "Add Option",
    delete_option: "Delete Option",
    options: "Options",
};
